export var AriaLiveOptionType;
(function (AriaLiveOptionType) {
    AriaLiveOptionType["POLITE"] = "polite";
    AriaLiveOptionType["ASSERTIVE"] = "assertive";
    AriaLiveOptionType["OFF"] = "off";
})(AriaLiveOptionType || (AriaLiveOptionType = {}));
//# sourceMappingURL=ariaLiveOption.js.map